import React from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import isEmpty from 'lodash-es/isEmpty';
//componentWillMount console log warning is still happening for AddToCalendar component
//I updated the forked package and built and pushed the new dist file
//fix ui/li issue where you click the ul but a li item and it doesn't close overlay
//fix in future sprint - Ken 11.6.20
import AddToCalendar from 'react-add-to-calendar';

import { timeWithZoneOffset } from '@evdy/web-core/dist/lib/utils';
import MultiLineText from '@evdy/web-core/dist/components/shared/elements/MultiLineText';
import Map from '@evdy/web-core/dist/components/shared/elements/Map';

import styles from './EventCard.module.scss';

import eventHouse from '../../../public/images/icons/event-house.svg';
import locationIcon from '../../../public/images/icons/location-icon.svg';

const {
  'event-card': eventCardClass,
  'start-time': startTimeClass,
  description: descriptionClass,
  title: eventTitleClass,
  'location-name': locationNameClass,
  'house-icon': eventHouseIconClass,
  address: addressClass,
  'location-icon': locationIconClass,
  'map-container': mapContainerClass,
  'map-image': mapImageClass,
  'get-directions-btn': getDirectionsBtn,
  'view-livestream-btn': viewLivestreamBtnClass,
  'directions-calendar-container': directionsCalendarContainerClass
} = styles;

const EventCard = ({ event, closeOverlayFn }) => {
  const { mobileOS } = useSelector(({ mobileOS }) => ({
    mobileOS
  }));
  const { title, startDateISO, location, coords = [], description, startTimeTBD, videoStreamUrl } =
    event || {};
  //confirm startDateISO exists on service, older services don't use ISO
  const eventDate = !!startDateISO && timeWithZoneOffset(new Date(startDateISO));
  const momentStartDate = !!eventDate && moment(eventDate);
  const startTimeString =
    momentStartDate._isValid && !startTimeTBD
      ? `${momentStartDate.format('dddd, MMM. DD')} at ${momentStartDate.format('LT')}`
      : `${momentStartDate.format('dddd, MMM. DD')}`;
  const { name, state, city, address } = location || {};
  //old memos with no location on an event could have coords be [0]
  const showMap = !isEmpty(location) && coords.length > 1;
  const mapLink =
    coords?.length > 1
      ? `https://www.google.com/maps/dir/?api=1&destination=${coords[0]},${coords[1]}`
      : '#';
  const locationObject = {
    name: location?.name,
    street: location?.address,
    city: location?.city,
    state: location?.state,
    coords
  };

  const makeLocString = loc => {
    return loc && loc.street
      ? `${loc.street}, ${!!loc.city ? loc.city : ''}${!!loc.city && !!loc.state ? ', ' : ''}${
          !!loc.state ? loc.state : ''
        }${!!loc.state && !!loc.zip ? ' ' : ''}${!!loc.zip ? loc.zip : ''}`
      : '';
  };

  const calListItems =
    mobileOS.os === 'iOS' && mobileOS.ua === 'Chrome'
      ? [{ google: 'Google' }, { outlookcom: 'Outlook.com' }, { yahoo: 'Yahoo' }]
      : [
          { apple: 'Apple Calendar' },
          { google: 'Google' },
          { outlook: 'Outlook' },
          { outlookcom: 'Outlook.com' },
          { yahoo: 'Yahoo' }
        ];

  // make sure stream URL has protocol so that the link is absolute when used in <a> tag,
  // since it is possible to enter a URL w/o the protocol
  const streamUrlHasProtocol = videoStreamUrl?.match(/https?:\/\//i);
  const formattedStreamUrl =
    !!videoStreamUrl && !streamUrlHasProtocol ? `http://${videoStreamUrl}` : videoStreamUrl;

  return (
    <div className={eventCardClass}>
      {!!startTimeString && <div className={startTimeClass}>{startTimeString}</div>}
      <div className={eventTitleClass}>{title}</div>
      <div className={descriptionClass}>
        {/* MultiLineText can handle empty string but not null for description */}
        {!!description && <MultiLineText text={description} _blank />}
      </div>
      {!!name && (
        <div className={locationNameClass}>
          <img src={eventHouse} alt="house-icon" className={eventHouseIconClass} />
          {name}
        </div>
      )}
      {(!!address || !!city || !!state) && (
        <div className={addressClass}>
          <img src={locationIcon} alt="location-icon" className={locationIconClass} />
          {[address, city, state].filter(Boolean).join(', ')}
        </div>
      )}
      {/* confirm map scaling is good with smaller modal */}
      {showMap && (
        <a className={mapContainerClass} href={mapLink} target="_blank" rel="noopener noreferrer">
          <Map
            isBackground
            mapClass={mapImageClass}
            data={locationObject}
            customSize="640x640"
            zoom={17}
          />
        </a>
      )}
      <div className={directionsCalendarContainerClass}>
        {showMap && (
          <a href={mapLink} target="_blank" rel="noopener noreferrer" className={getDirectionsBtn}>
            Get directions
          </a>
        )}
        <AddToCalendar
          event={{
            ...event,
            startTime: timeWithZoneOffset(new Date(startDateISO)),
            endTime: timeWithZoneOffset(new Date(startDateISO)),
            location: makeLocString(locationObject)
          }}
          buttonLabel="Add to calendar"
          buttonWrapperClass="add-calendar"
          dropdownClass="add-calendar-dropdown"
          displayItemsIcons={false}
          listItems={calListItems}
          closeOverlayFn={closeOverlayFn}
        />
      </div>
      {!!formattedStreamUrl && (
        <a
          href={formattedStreamUrl}
          target="_blank"
          rel="noopener noreferrer"
          className={viewLivestreamBtnClass}
        >
          View livestream
        </a>
      )}
    </div>
  );
};

export default EventCard;
